/**
 * Origem Flow: serviço do hub de Docs (/api/docs/*).
 */
export default (client) => {
  return {
    fetchAll(workspaceId, { tableId = null, rowId = null } = {}) {
      const params = {}
      if (tableId) {
        params.table_id = tableId
      }
      if (rowId) {
        params.row_id = rowId
      }
      return client.get(`/docs/workspace/${workspaceId}/`, { params })
    },
    create(
      workspaceId,
      { name = '', parentId = null, content = null, docType = '' } = {}
    ) {
      return client.post(`/docs/workspace/${workspaceId}/`, {
        name,
        parent_id: parentId,
        content,
        doc_type: docType,
      })
    },
    get(documentId) {
      return client.get(`/docs/${documentId}/`)
    },
    exportPdf(documentId, markdown) {
      return client.post(
        `/docs/${documentId}/export-pdf/`,
        { markdown },
        { responseType: 'blob' }
      )
    },
    update(documentId, values) {
      return client.patch(`/docs/${documentId}/`, values)
    },
    delete(documentId) {
      return client.delete(`/docs/${documentId}/`)
    },
  }
}
